<template>
    <div class="gp-app-video">
        <gp-image v-show="posterVisible || !(videoVisible && $root.$data.videoView)" :src="poster" class="gp-app-video__poster"></gp-image>
        <video
            id="video_one"
            ref="video"
            class="gp-app-video__video"
            preload="none"
            :class="{'is-visible': videoVisible && $root.$data.videoView}"
            :src="src"
            muted
        ></video>
        <div class="gp-app-video__control">
            <div v-if="paused" class="gp-app-video__play-btn" @click="showAndPlay(true)">
            </div>
            <div v-else class="gp-app-video__control-bar">
                <div class="gp-app-video__pause-btn" @click="pause(true)"></div>
                <div class="gp-app-video__mute" :class="{'is-muted': muted}" @click="toggleMute"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import GpImage from '@/components/gp-image';
    import { on } from '@/utils/dom';
    import {getQueryString, getUrlParams} from '@/utils/url';

    export default {
        components: {
            GpImage
        },
        props: {
            poster: {
                type: String,
                required: true
            },
            src: {
                type: String,
                required: true
            },
            appVideoInfo: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                posterVisible: true,
                paused: true,
                videoVisible: false,
                muted: true,
                lastStatus: {
                    paused: true,
                    videoVisible: false
                }
            }
        },
        mounted() {
            on(this.$refs.video, 'ended', () => {
                this.paused = true;
            });
            if (this.$wifi) {
                this.$refs.video.muted = true;
                this.showAndPlay();
            }
        },
        methods: {
            logPush(clk) {
                const {channelid} = getUrlParams();
                const {app_name, package_name, app_id, app_type} = this.appVideoInfo;
                this.$logger.click({
                    source: channelid,
                    ext: {
                        id: package_name,
                        ext: {
                            clickState: clk ? "start" : "pause",
                            sid: getQueryString('sid'),
                            srcId: getQueryString('srcid'),
                            gameId: app_id,
                            gameType: app_type,
                            gameName: app_name
                        },
                        pos: ''
                    },
                    value: "videoPlay",
                    network: this.$wifi ? 'wifi' : '4g'
                });
            },
            showAndPlay(log) {
                log && this.logPush(true);
                this.show();
                this.play();
            },
            play() {
                this.$refs.video.play();
                this.muted = this.$refs.video.muted;
                this.posterVisible = false;
                this.paused = false;
            },
            pause(log) {
                log && this.logPush(false);
                this.lastStatus.paused = this.paused;
                this.lastStatus.videoVisible = this.videoVisible;
                this.$refs.video.pause();
                this.paused = true;
            },
            toggleMute() {
                this.$refs.video.muted = !this.$refs.video.muted;
                this.muted = this.$refs.video.muted;
            },
            show() {
                this.videoVisible = true;
            },
            hide() {
                this.videoVisible = false;
            },
            restore() {
                if (!this.lastStatus.paused) {
                    this.play();
                }
                if (this.lastStatus.videoVisible) {
                    this.show();
                }
            }
        }
    }
</script>

<style scope lang="scss">
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/mixins";
    $design-width: 1242;

    @include b(app-video) {
        width: 100%;
        height: px2rem(618);
        position: relative;

        @include e(poster) {
            width: 100%;
            height: 100%;
        }

        @include e(video) {
            width: 1px;
            height: 1px;
            object-fit: fill;

            @include when(visible) {
                width: 100%;
                height: 100%;
            }
        }

        @include e(control) {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
        }

        @include e(play-btn) {
            width: px2rem(140);
            height: px2rem(140);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: url('~public/assets/imgs/play.png') no-repeat;
            background-size: contain;
        }

        @include e(control-bar) {
            width: 100%;
            height: px2rem(80);
            background: rgba(0, 0, 0, 0.2);
            position: absolute;
            bottom: 0;
            left: 0;
            display: flex;
            align-items: center;
            border-bottom-left-radius: px2rem(39);
            border-bottom-right-radius: px2rem(39);
        }

        @include e(pause-btn) {
            width: px2rem(50);
            height: px2rem(40);
            margin: 0 px2rem(15) 0 px2rem(30);
            background: url('~public/assets/imgs/pause.png') no-repeat;
            background-size: cover;
        }

        @include e(mute) {
            width: px2rem(50);
            height: px2rem(50);
            margin: 0 px2rem(15);
            background: url('~public/assets/imgs/voice.png') no-repeat;
            background-size: cover;

            @include when(muted) {
                background: url('~public/assets/imgs/mute.png') no-repeat;
                background-size: cover;
            }
        }
    }

</style>
